var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5468_3469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 18,
    fill: "#ECFEF9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7676 31H9.23188C8.55159 31 8 31.6716 8 32.5C8 33.3284 8.55159 34 9.23188 34H30.7681C31.4484 34 32 33.3284 32 32.5C32 31.6716 31.4479 31 30.7676 31Z",
    fill: "url(#paint0_linear_5468_3469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0404 12.9043C32.8829 12.9043 31.945 13.8423 31.945 14.9997C31.945 15.5797 32.1807 16.1044 32.5611 16.4837L26.0512 19.9398L20.9408 10.3653C21.7612 10.023 22.3381 9.21415 22.3381 8.26992C22.3381 7.01634 21.3217 6 20.0681 6C18.8146 6 17.7982 7.01634 17.7982 8.26992C17.7982 9.21415 18.3751 10.0236 19.1955 10.3653L14.085 19.9398L7.57523 16.4837C7.95564 16.1044 8.1913 15.5797 8.1913 14.9997C8.1913 13.8423 7.25334 12.9043 6.09591 12.9043C4.93848 12.9043 4 13.8423 4 14.9997C4 16.1572 4.93796 17.0951 6.09539 17.0951C6.14503 17.0951 6.19415 17.0909 6.24327 17.0878L8.63623 29H31.5288L33.893 17.0878C33.9421 17.0915 33.9907 17.0951 34.0409 17.0951C35.1983 17.0951 36.1363 16.1572 36.1363 14.9997C36.1363 13.8423 35.1978 12.9043 34.0404 12.9043Z",
    fill: "url(#paint1_linear_5468_3469)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 25.6966C17.5758 25.6966 17.3866 25.6402 17.2658 25.5275C17.1531 25.4068 17.0968 25.2337 17.0968 25.0083C17.0968 24.8714 17.133 24.7386 17.2055 24.6098C17.2779 24.481 17.3826 24.3441 17.5194 24.1992L19.9466 21.615C20.3169 21.2286 20.5826 20.8784 20.7436 20.5644C20.9046 20.2424 20.9851 19.9204 20.9851 19.5984C20.9851 19.1959 20.8563 18.8899 20.5987 18.6806C20.3491 18.4713 19.9828 18.3667 19.4998 18.3667C19.2261 18.3667 18.9524 18.4069 18.6787 18.4874C18.405 18.5599 18.1272 18.6887 17.8455 18.8738C17.7006 18.9704 17.5637 19.0107 17.4349 18.9946C17.3141 18.9785 17.2055 18.9262 17.1089 18.8376C17.0203 18.7491 16.9599 18.6404 16.9277 18.5116C16.8955 18.3828 16.8995 18.254 16.9398 18.1252C16.9881 17.9883 17.0847 17.8716 17.2296 17.775C17.5758 17.5415 17.9622 17.3644 18.3889 17.2436C18.8236 17.1229 19.2583 17.0625 19.693 17.0625C20.3049 17.0625 20.8201 17.1551 21.2387 17.3402C21.6573 17.5254 21.9753 17.7951 22.1927 18.1493C22.41 18.5035 22.5187 18.9342 22.5187 19.4414C22.5187 19.7795 22.4624 20.1096 22.3497 20.4316C22.245 20.7536 22.08 21.0797 21.8546 21.4097C21.6372 21.7398 21.3514 22.09 20.9972 22.4603L18.727 24.8271V24.4166H22.2772C22.4946 24.4166 22.6596 24.4689 22.7723 24.5735C22.885 24.6782 22.9414 24.8352 22.9414 25.0445C22.9414 25.2538 22.885 25.4148 22.7723 25.5275C22.6596 25.6402 22.4946 25.6966 22.2772 25.6966H17.8334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5468_3469",
    x: 0,
    y: 2,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5468_3469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5468_3469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5468_3469",
    x1: 20,
    y1: 31,
    x2: 20,
    y2: 34.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B8A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5468_3469",
    x1: 20.0681,
    y1: 6,
    x2: 20.0681,
    y2: 29.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B8A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2);
export default __webpack_public_path__ + "static/media/level2.6d3221de30ca8c3afc72427efcfeae85.svg";
export { ForwardRef as ReactComponent };